import React from 'react';
import SnapshotOption from './SnapshotOption';
import SnapshotResult from './SnapshotResult';
import './SnapshotCreateMain.css'
import SnapshotCreateOptionBar from './SnapshotCreateOptionBar';

const SnapshotCreateMain = (props) => {
  
  return (
    <>
      <SnapshotCreateOptionBar
        onDateBtn={props.onDateBtn} minDate={props.minDate} handleDate={props.handleDate} dateRange={props.dateRange} handleDateBtn={props.handleDateBtn}
        edit={props.edit} defaultQuery={props.defaultQuery} querySelectOption={props.querySelectOption} selectMainQuery={props.selectMainQuery} mainQuery={props.mainQuery}
        subQueryType={props.subQueryType} handleSubQueryType={props.handleSubQueryType} selectSubQuery={props.selectSubQuery} multiQuerySelectOption={props.multiQuerySelectOption} 
        defaultReportType={props.defaultReportType} reportTypeSelectOption={props.reportTypeSelectOption} selectReportType={props.selectReportType}
        channels={props.channels} handleChannels={props.handleChannels} handleRunBtn={props.handleRunBtn} 
        handleSaveBtn={props.handleSaveBtn} userLabelData={props.userLabelData}
      />
      <div className="row featured-main">
        <SnapshotResult options={props.options} volumeResult={props.volumeResult} sentimentResult={props.sentimentResult} sourceResult={props.sourceResult} categoryResult={props.categoryResult} relationResult={props.relationResult} positioningmapResult={props.positioningmapResult}
          handleSaveBtn={props.handleSaveBtn} userRole={props.userRole}
        />
      </div>
    </>
    // <div className="row featured-main">
    //   <table width="100%" border="0" cellspacing="0" cellpadding="0">
    //     <tr>
    //       <td width="22%" valign="top">
    //         <SnapshotOption handleRunBtn={props.handleRunBtn} minDate={props.minDate} handleDate={props.handleDate} dateRange={props.dateRange} handleDateBtn={props.handleDateBtn}
    //           reportTypeSelectOption={props.reportTypeSelectOption} selectReportType={props.selectReportType}
    //           channelSelectOption={props.channelSelectOption} selectChannel={props.selectChannel}
    //           querySelectOption={props.querySelectOption} selectMainQuery={props.selectMainQuery} mainQuery={props.mainQuery}
    //           multiQuerySelectOption={props.multiQuerySelectOption} subQueryType={props.subQueryType} selectSubQuery={props.selectSubQuery} handleSubQueryType={props.handleSubQueryType}
    //           onDateBtn={props.onDateBtn} defaultQuery={props.defaultQuery} edit={props.edit} defaultChannel={props.defaultChannel} defaultReportType={props.defaultReportType}
    //         />
    //       </td>
    //       <td width="78%" valign="top">
    //         <SnapshotResult options={props.options} volumeResult={props.volumeResult} sentimentResult={props.sentimentResult} sourceResult={props.sourceResult} categoryResult={props.categoryResult} relationResult={props.relationResult} positioningmapResult={props.positioningmapResult}
    //           handleSaveBtn={props.handleSaveBtn} userLabelData={props.userLabelData} edit={props.edit} userRole={props.userRole}
    //         />
    //       </td>
    //     </tr>
    //   </table>
    // </div>
  )
}

export default SnapshotCreateMain;